import React , {useState , useEffect} from "react";
import { v4 as uuidv4 } from "uuid";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import s from "../Charts.module.scss";
import Dot from "../../../../components/Dot/Dot";
import BaseAPI from "../../../../api/apiurl"



const RechartsPieChart = () => {

  const [open, setOpen] = useState(null);
  const [closed, setClosed] = useState(null);


  const Dashboardcount = () =>{
   
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');

    if (company_id && customer_id) {
    
      const apiUrl = `${BaseAPI}servicedash?company_id=${company_id}&customer_id=${customer_id}`;

      // Make an HTTP GET request using fetch
      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .then((data) => {
          setOpen(data.data[0].open);
          setClosed(data.data[0].closed);
          
        })
        .catch((error) => {
          console.log (error);
        });
    } else {
      console.log ('company_id and customer_id not found in local storage');
    }
  }
  useEffect(() => {
   Dashboardcount(); 
  }, []);

 
  const chartsSettings = {
    donut: {
      data: [
        { name: 'InProgress', value:50, color: '#FFC405' },
        { name: 'Completed',  value:60, color: '#4D53E0' },
      ],
    }
  };

  console.log( "open" , open);
  console.log( "closed" , closed);

  return (
    <div style={{ height: "230px" }}>
      <ResponsiveContainer width="100%" height={160}>
        <PieChart >
          <Pie
            data={chartsSettings.donut.data}
            innerRadius={50}
            outerRadius={80}
            dataKey="value"
          >
            {chartsSettings.donut.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className={s.donutLabels}>
        {chartsSettings.donut.data.map((entry, index) => (
          <div key={uuidv4()} className={s.label}>
            <Dot color={entry.color} />
            <span className="body-3 ml-2">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
};

export default RechartsPieChart;
